const passkey_sign_in = {
    setup_page: {
        title: 'Спростіть вхід',
        subtitle: 'Створіть ключ-пароль',
        description: 'Зареєструйте ключ-пароль за допомогою біометрії пристрою, ключів безпеки на кшталт YubiKey чи інших доступних методів.',
    },
    trigger_conditional_ui_failed: 'Не вдалося запустити автозаповнення ключа-пароля.',
};
export default Object.freeze(passkey_sign_in);
